/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Voucher from "./Voucher";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import { onProductByProductIdSubmit } from "../../Store/Slices/productSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import BackSections from "../Giftcards/BackSections";
import { decryptURLParam } from "../../Common/Axios/encrypt";

// Old code:
// const LetShop3 = (arrayData) => {
//   const location = useLocation();
//   const modalData = location.state?.moduleData;
//   const dispatch = useDispatch();
//   const [enhancedProductReducer, setEnhancedProductReducer] = useState(null);
//   const productReducer = useSelector(
//     (state) => state.productReducer?.productByProductId
//   );
//   const productDiscount = useSelector(
//     (state) =>
//       state?.ClientProductMappingbyIdReducer?.data?.[0]?.clientProductMapping
//   );

//   useEffect(() => {
//     if (productReducer && productDiscount) {
//       const discount = productDiscount.find(
//         (discountItem) => discountItem.productId === productReducer[0]?.id
//       );
//       const customerDiscount = discount?.customerDiscount;
//       setEnhancedProductReducer({
//         ...productReducer[0],
//         customerDiscount,
//         priceDenomination: discount?.priceDenomination,

//       });
//     }
//   }, [productReducer, productDiscount]);

//   const url = window.location.href.split("=")[1];

//   useEffect(() => {
//     dispatch(onProductByProductIdSubmit(url));
//   }, [url]);
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
//   useEffect(() => {
//     const handleResize = () => setIsMobileView(window.innerWidth <= 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);
//   return (
//     <section className={`letshop3 ${!isMobileView ? "bg" : ""} `}>
//       <ScrollToTop />
//       <BackSections />
//       <div className="container">
//         <div className="flex-container">
//           <div className="voucher-section">
//             <Voucher
//               productReducer={productReducer}
//               productReducerDisocount={enhancedProductReducer}
//               arrayData={arrayData}
//               modalProductData={modalData}
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };


const LetShop3 = (arrayData) => {
  const location = useLocation();
  const modalData = location.state?.moduleData;
  const dispatch = useDispatch();
  const [enhancedProductReducer, setEnhancedProductReducer] = useState(null);
  const productData = useSelector((state) => state?.productDataReducer?.data)
  
  // const productReducer = useSelector(
  //   (state) => state.productReducer?.productByProductId
  // );
  // const productDiscount = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer?.data?.[0]?.clientProductMapping
  // );

  useEffect(() => {
    if (productData) {
      setEnhancedProductReducer({
        ...productData,
        priceDenomination: productData?.priceDenominations,
    })
    }
  }, [productData]);

  // Conditionally decrypt the productId from URL based on environment setting
  const encryptedProductId = window.location.href.split("=")[1];
  const url = encryptedProductId 
    ? (process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false' 
        ? encryptedProductId 
        : decryptURLParam(encryptedProductId)) 
    : null;

  // useEffect(() => {
  //   dispatch(onProductByProductIdSubmit(url));
  // }, [url]);

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className={`letshop3 ${!isMobileView ? "bg" : ""} `}>
      <ScrollToTop />
      <BackSections />
      <div className="container">
        <div className="flex-container">
          <div className="voucher-section">
            <Voucher
              productReducer={productData}
              productReducerDisocount={enhancedProductReducer}
              arrayData={arrayData}
              modalProductData={modalData}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LetShop3;
